<template>
  <v-tooltip location="bottom">
    <template v-slot:activator="{ props }">
      <v-btn
        class="px-0 ml-2"
        v-bind="props"
        icon
        variant="text"
        @click="copyToClipboard"
      >
        <v-icon> mdi-content-copy </v-icon>
      </v-btn>
    </template>
    <span>Kopieren</span>
  </v-tooltip>
</template>

<script lang="ts">
import { clipboard } from '@/lib/clipboard'
import bus, { eventNames } from '@/lib/eventBus'

export default {
  props: {
    value: { type: String, default: '' },
  },
  methods: {
    async copyToClipboard() {
      this.$tracking.event('Settings', 'Clicked', 'Copy to Clipboard')
      bus.$emit(eventNames.SHOW_SNACKBAR, {
        color: 'success',
        text: 'In die Zwischenablage kopiert.',
      })

      return await clipboard(this.value)
    },
  },
}
</script>
